import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Welcome to the Hubcapp User Guide"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "welcome-to-the-hubcapp-user-guide",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#welcome-to-the-hubcapp-user-guide",
        "aria-label": "welcome to the hubcapp user guide permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Welcome to the Hubcapp User Guide`}</h1>
    <h2 {...{
      "id": "introduction",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#introduction",
        "aria-label": "introduction permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Introduction`}</h2>
    <p>{`You can use Hubcapp to manage your driving school business, from your calendar diary, your learners, your settings and much more.`}</p>
    <blockquote>
      <p parentName="blockquote">{`If you are here for the first time setting up Hubcapp or a new instructor with the AA or BSM, then please ensure your `}<a parentName="p" {...{
          "href": "../usage/areas-and-prices"
        }}>{`areas and prices`}</a>{` are setup so that we can start assigning you learners.`}</p>
    </blockquote>
    <h2 {...{
      "id": "menu",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#menu",
        "aria-label": "menu permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Menu`}</h2>
    <p>{`The main menu is on the left hand side of the homepage on a desktop computer or behind the 3 lines menu on a mobile. `}</p>
    <p>{`The main sections we will discuss in these help pages will be in the menu. `}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "960px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "56.25%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAAClklEQVQoz0WQTUgUcRjG91LdLA9BBpEpaYgV1iGJyuzjUF2CLh68dPKsqd3Ec9IpIehQlIlrbLm7HoIIKZC9iMQKLmUr6q7uzs73f2Zn52Nn3qf/zGr+4eF9GOZ93t/7xl5PTqC/9TQutJ3B+bMt6Ghtwcnm43g2MoKD93NpCTd6OnD91k3cv92Hh/f60HvlEq71XMTlrg50d7ZRd2c7r+0UGxoYRtfgW/Q+mULz4AecGJjF1adjGBp/Dsd2osDEtxWcejyNc4Pv0PRoGk0PXuHY3Zc40j+Fo3ci0UGNzbyYRiqRwY+VAr7mTHz/42BtT8XM/CfoOosCM7kSJuK7mHyzjvH3BYx+YRiOSxj7rGE0oWEsoRFX6Ck2N/sRleI2ZFWCVCnBZEpEllxIQlPVKLCyuQF9dRWeUAby64BeQUAOSsUtME2EpgikK0LoKTY7F4eoGWBVG2bNhWE5XDYWkikw1iAsZzK8uQTNrcMPAPYrC1lhyG3u4PdmAet/tyiX3w49xeb5apKsoMap/CCA63rc20il0mCmCTgOijxQ4V4UKiA+wM7noZYEaHy4ZbuwHI+4eHUbgZZlRSGhiCiiSqcPA3eWl6GaVaiKCg4Ip1iEXtiFapio1WrhEAoCAlcj0PPqUYhbD8DsAJZHh4F2g5DxRqkiRoEhoV6uQOdDJInfXpZJ3K+xuXicFI0RMy2q1hyqcexQyVSa+A1DXBIyGZIFgVTbJtt1ycyukcFMUnVGsqKSYRik83szZlAszgltTuF6XnQ/j9e673PCRTBdj8j3NjZQ4mvLnMzIZuGUyqh6PkRRQqkshGSocM8po5WpXq/zGwTk+36k8KUXF/8TlkWRXF0nr1Agn1effzOqNfL2+8J/DvQPgIrpbjEk49AAAAAASUVORK5CYII=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/static/e3b0ca1a65dde12f859c77773d30327c/8ac56/menu2.webp 240w", "/static/e3b0ca1a65dde12f859c77773d30327c/d3be9/menu2.webp 480w", "/static/e3b0ca1a65dde12f859c77773d30327c/e46b2/menu2.webp 960w"],
            "sizes": "(max-width: 960px) 100vw, 960px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/static/e3b0ca1a65dde12f859c77773d30327c/8ff5a/menu2.png 240w", "/static/e3b0ca1a65dde12f859c77773d30327c/e85cb/menu2.png 480w", "/static/e3b0ca1a65dde12f859c77773d30327c/d9199/menu2.png 960w"],
            "sizes": "(max-width: 960px) 100vw, 960px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/static/e3b0ca1a65dde12f859c77773d30327c/d9199/menu2.png",
            "alt": "menu location on a mobile and desktop",
            "title": "menu location on a mobile and desktop",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <hr></hr>
    <h2 {...{
      "id": "calendar",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#calendar",
        "aria-label": "calendar permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Calendar`}</h2>
    <p>{`This is the section where you can view your diary. `}</p>
    <p>{`You can see your upcoming lessons for the day, week or month. You can also book in lessons or time off events into the calendar. `}</p>
    <p>{`To change your calendar views, click the button to change views.`}</p>
    <p><strong parentName="p">{` `}<a parentName="strong" {...{
          "href": "/usage/calendar"
        }}>{`Learn how to setup your calendar`}</a>{` `}</strong></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "960px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "56.25%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAACm0lEQVQoz12RS0wTYRSFuzUxRhLXJMYdGuKjAqWo4ArYCIlxY9jVmJi41Y1x5QIWPnbEDaiREOOWhWBIW0MJtB3aEfsQSnnJY0o7nc50Ou97/GeKhPgnJ3Pnzp3vnjPj67zejv8VvHkV3Tc60eP343agA13X/JicnIR7NjeLePhgCP193RjoC6L/bhC3egI0PHQfwuEB+c4HQjitlu4QLvQ+xeC9EfgHQmgdfIHW3md4/2HKA36b/Y6WzhGcDT7BmcBjnOt8hEsdw9R+J4AfsTj52sYO0Da67+ky05WxPVx8JeLll88IfVxE1zsRHa93MB/PecD5cBTPP3F4u2hhdK6K8ekM5iN5mhh/g4UET769sgxX+5KGvYqCvaPmfWRNx2xORXxXw44gYfVXxgNGoxEsLkQhS2WUtgo4ikVg7u7SwtRXLHFJ8mmaDk03UN/ZQY3nIafTqKbSmJtJYWKax+RMEXJNRi7XdBgOhxFbTkJUNAiSgtL2H9TWi7S4EEM8kSCfYjqo/l7HVozDvqjhULGwK9uQNAuCYqLEZ1FKJJEtbHjASCQCbiUF3bRgMhmOAwJomc0kXKBcb0CVZIiZHCrpVYhrG6gWtyEWNlHmM6gwifuHyObzx8AoUmkelmWh0WjAMg23TRzHNR2WJRVi3UBZ0VEpV1AqbkHI5iGsFVA6ECCrGmpM2Wz2JHLmuHahqm43gcx1PM7+cuHIoMKRSRtCgyS5TlK9QVVVI4mpUq2RXFe9PgOS+yKLTFyKJ8N2SGEztbpOOku9FE80IzuODV3XvI2GacK22UYiaFqz5zgEBjxx6H7DNP8Tpu1AURsnc4kk9w/okG4Y3nbTNIkByT26rntXmz0/7ZBFZnXOq23bIhbbq1dWUuRG/gs1w9zcd2oSoAAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/static/7501e4054f1b842d5ba6eff7c6060566/8ac56/calendar.webp 240w", "/static/7501e4054f1b842d5ba6eff7c6060566/d3be9/calendar.webp 480w", "/static/7501e4054f1b842d5ba6eff7c6060566/e46b2/calendar.webp 960w"],
            "sizes": "(max-width: 960px) 100vw, 960px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/static/7501e4054f1b842d5ba6eff7c6060566/8ff5a/calendar.png 240w", "/static/7501e4054f1b842d5ba6eff7c6060566/e85cb/calendar.png 480w", "/static/7501e4054f1b842d5ba6eff7c6060566/d9199/calendar.png 960w"],
            "sizes": "(max-width: 960px) 100vw, 960px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/static/7501e4054f1b842d5ba6eff7c6060566/d9199/calendar.png",
            "alt": "Change calendar views",
            "title": "Change calendar views",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <hr></hr>
    <h2 {...{
      "id": "learners",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#learners",
        "aria-label": "learners permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Learners`}</h2>
    <p>{`This section shows you all your current and past learners in a list. `}</p>
    <p>{`You can search for a learner and bring up all their details or you can add a new learner into your Driving School.`}</p>
    <p><strong parentName="p">{` `}<a parentName="strong" {...{
          "href": "/usage/learners"
        }}>{`Discover how to view your learners`}</a>{` `}</strong></p>
    <hr></hr>
    <h2 {...{
      "id": "messages",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#messages",
        "aria-label": "messages permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Messages`}</h2>
    <p>{`This section of Hubcapp contains all your messages betwen you and the Call Centre agents.`}</p>
    <p>{`There are also other categories of news and updates for you to see the latest news about your Driving School.`}</p>
    <p><strong parentName="p">{` `}<a parentName="strong" {...{
          "href": "/usage/messages"
        }}>{`Understand more about messages`}</a>{` `}</strong></p>
    <hr></hr>
    <h2 {...{
      "id": "accounts",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#accounts",
        "aria-label": "accounts permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Accounts`}</h2>
    <p>{`View all of your financial transactions, invoices and more in this section.`}</p>
    <p><strong parentName="p">{` `}<a parentName="strong" {...{
          "href": "/usage/accounts-details-message-centre"
        }}>{`Learn more about accounts`}</a>{` `}</strong></p>
    <hr></hr>
    <h2 {...{
      "id": "my-details",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#my-details",
        "aria-label": "my details permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`My Details`}</h2>
    <p>{`View your peronal details and franchise details.`}</p>
    <p>{`In this section is listed your franchise details, business details, qualifications and car details.`}</p>
    <p><strong parentName="p">{` `}<a parentName="strong" {...{
          "href": "/usage/accounts-details-message-centre"
        }}>{`Understand your franchise details`}</a>{` `}</strong></p>
    <hr></hr>
    <h2 {...{
      "id": "areas-and-prices",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#areas-and-prices",
        "aria-label": "areas and prices permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Areas and prices`}</h2>
    <p>{`See what areas you deliver lessons in.`}</p>
    <p>{`An important part of the Hubcapp setup &en; which areas you cover for driving lessons. this will determine if you show as an instructor when a learner enters a postcode.`}</p>
    <p><strong parentName="p">{` `}<a parentName="strong" {...{
          "href": "/usage/areas-and-prices"
        }}>{`See how to manage your areas and prices`}</a>{` `}</strong></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "960px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "56.25%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAACcklEQVQoz02RS0hUYRTHZ1uLaB9BGwV1rMwiCjK1NlHgJkhoYY9t0LZd+yDaBb02glGSM1rRRM6YYDoihUkghDZzx9ExZ7oz9/Hd98z5d77vKnXgz/nuOYdzfufcxEwuizO93TjZ3Y7eZBv7NrQfOYzha8PIfMjg9KkTOHtuEOf7L2BgYBB9ff3o6elFR0eXUmdnUoo6OuW7ixKPn49i/8X7ODj0CAeuPMC+Sw9xaOgeLl+/iqcvcxi8+xF9dzJIjkzh2K33OH6bxf7ozbfovjGl4uwpOTIp35R4/WYST7IaXn2zMLpQxdiSidmCwFhqHNOfF7FSCrGsBfiuRVhaczG3aivN/qjjy6qF/E9HivZ8IpWawMrKMrY2CigV1yCMGqR9mp7BwvwcokCAIgextaDrNVQqZZTLRWyWNdSqFSn6vV1GdadCiYmJFLSNTZjCg+cKLKxbeLbo4MV4Bl+XFtEwbTQMC60WwfVDmJZAvWFArxuwbAdRs4UwalIYSd9iwrfvsD0/j8g0eD4QhpFimc7mkM/nIRwHhmmqmOcH8MMm9kx+W7Zg75PreXBcjxLp9CQKa+twPR9eEEC4rirO5WZUQy6CZdkcIc5H8IUD8j1V43KtYRhSZPJQFhOm0yiWSnCYxIyTqjibiwkt20ZN1xGFIXxe26tswSn8guR0JT3Xy0ayoWVZkjBNRU0jniaDJIMShxsSNyS5Dq9N0jw/JJ/vpXBZDEGSblcxITdEoVCEEAKNRgP1en2XMF75f/OCkE8ToBn/CHVvqeCfYkJuSLZtq0m6rqvpfENFuEcj5QcRmbagnWqN/uh19lVFL3Mtiu0vnEDsVR/4aY0AAAAASUVORK5CYII=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/static/c9c6167052dbdc13c6e546b3e11504cd/8ac56/areas-and-prices.webp 240w", "/static/c9c6167052dbdc13c6e546b3e11504cd/d3be9/areas-and-prices.webp 480w", "/static/c9c6167052dbdc13c6e546b3e11504cd/e46b2/areas-and-prices.webp 960w"],
            "sizes": "(max-width: 960px) 100vw, 960px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/static/c9c6167052dbdc13c6e546b3e11504cd/8ff5a/areas-and-prices.png 240w", "/static/c9c6167052dbdc13c6e546b3e11504cd/e85cb/areas-and-prices.png 480w", "/static/c9c6167052dbdc13c6e546b3e11504cd/d9199/areas-and-prices.png 960w"],
            "sizes": "(max-width: 960px) 100vw, 960px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/static/c9c6167052dbdc13c6e546b3e11504cd/d9199/areas-and-prices.png",
            "alt": "View the areas you cover",
            "title": "View the areas you cover",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <hr></hr>
    <h2 {...{
      "id": "preferences",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#preferences",
        "aria-label": "preferences permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Preferences`}</h2>
    <p>{`Settings for your driving school franchise.`}</p>
    <p>{`Determine important settings such as working hours, which days you work and travelling time between lessons. `}</p>
    <p><strong parentName="p">{` `}<a parentName="strong" {...{
          "href": "/usage/preferences"
        }}>{`View how to change your settings`}</a>{` `}</strong></p>
    <hr></hr>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      